import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PageTitleState {
  title: string;
  subtitle: string;
}

@Injectable({ providedIn: 'root' })
export class PageTitleService {
  private _state = new BehaviorSubject<PageTitleState>({
    title: 'BookBridge',
    subtitle: 'Library Management System',
  });

  readonly title$ = this._state.asObservable();

  set(title: string, subtitle: string): void {
    this._state.next({ title, subtitle });
  }
}
